import { Link } from '../../types';
import { FooterLink } from '../FooterLink/FooterLink';
import styles from './FooterList.module.scss';

export type FooterListProps = {
  links: Link[];
  heading: string;
  id: string;
  onLinkClick?: (link: Link, e: React.MouseEvent) => void;
  refTargets?: Record<string, () => void>;
};

export const FooterList: React.FC<FooterListProps> = ({ links, heading, id, onLinkClick, refTargets }) => {
  return (
    <div>
      <h3 id={id} className={styles.footerHeading}>
        {heading}
      </h3>
      <ul aria-labelledby={id}>
        {links.map((link: Link, i: number) => {
          const handleClick = (e: React.MouseEvent) => {
            if (link.refTarget && refTargets?.[link.refTarget]) {
              e.preventDefault();
              refTargets[link.refTarget]();
            } else if (onLinkClick) {
              onLinkClick(link, e);
            }
          };

          return (
            <li key={i}>
              <FooterLink link={link} onClick={handleClick} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
